// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ioau","clinicsSelect":"styles_clinicsSelect__qvTmg"};